<template lang="html">
  <img
    class="brand-logo"
    src="@/assets/logo.svg"
    alt="Omroep West"
    width="260"
  />
  <div class="container form-wrap">
    <h1 class="title h-100">Vul je gegevens in</h1>
    <input
      v-model="firstName"
      class="form-control field no-focusborder"
      type="text"
      ref="inputfield"
      placeholder="Voornaam"
      required
    />
    <input
      v-model="lastName"
      class="form-control field no-focusborder"
      type="text"
      ref="inputfield"
      placeholder="Achternaam"
      required
    />
    <input
      v-model="email"
      class="form-control field no-focusborder"
      type="email"
      ref="inputfield"
      placeholder="E-mailadres"
      required
    />
    {{ validateEmail }}
    <div class="d-grid gap-2">
      <button
        type="button"
        class="btn btn-secondary text-light btn-lg rounded-0"
        :disabled="isDisabled == true"
        @click="setPersonalData()"
      >
        Volgende
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PersonalDataScreen",
  data: () => ({
    firstName: null,
    lastName: null,
    email: null,
  }),
  computed: {
    isDisabled() {
      if (this.firstName && this.lastName && this.email) {
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
          return false;
        }
      }
      return true;
    },
    validateEmail() {
      let msg;
      if (this.email !== null) {
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
          msg = "";
        } else {
          msg = "Vult u een geldig email adres in";
        }
      }
      return msg;
    },
  },
  methods: {
    setPersonalData() {
      this.$store.commit("setFirstName", this.firstName);
      this.$store.commit("setLastName", this.lastName);
      this.$store.commit("setCompany", "");
      this.$store.commit("setPhone", "");
      this.$store.commit("setEmail", this.email);
      this.$store.commit("setQuestionOne", null);
      this.$store.commit("setQuestionTwo", null);
      this.$store.commit("setQuestionThree", null);
      this.$store.commit("setQuestionFour", null);
      this.$store.commit("setQuestionGdpr", null);
      this.$store.commit("setSavedData", null);
    },
  },
};
</script>

<style lang="css" scoped>
h1 {
  font-size: 1.8rem;
  color: #ffffff;
  font-weight: 700;
}
.title {
  padding-bottom: 14px;
}
.brand-logo {
  margin-bottom: 20px;
}
.form-wrap {
  max-width: 100%;
}
.field {
  margin-bottom: 12px !important;
  outline: none;
  padding: 12px 14px;
  font-size: 1rem;
  text-align: left;
  color: #333;
  background-color: #fff;
  border: none;
  border-radius: 4px;
}
.field::placeholder {
  color: #999;
}

@media (min-width: 768px) {
  h1 {
    font-size: 2rem;
  }

  .field {
    font-size: 1.1rem;
    padding: 14px;
  }
}
</style>
